<template>  
<div  ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">    
    <v-progress-circular v-if="loadingData" :width="15" :size="350" :value="loadingValue" color="primary"  style="align-self:center;margin-bottom:auto;margin-top:auto">
      <span class="headline">{{$t('Pilot.Graphics.LoadingData')}}</span>
    </v-progress-circular> 
    <div v-else-if="!loadedData">                
      <v-alert  :value="true" type="info"  >{{$t('Pilot.Graphics.FailDownloadData')}}</v-alert>
      <v-btn color="primary" @click="tryEnsureData()">{{$t('Pilot.Graphics.TryReload')}}</v-btn>
    </div>                
    <template v-else-if="mission.dataNavigation.length > 0">
      <v-layout row justify-center style="flex:0 0 auto;">
        <v-btn small :color="dataLimitMode === dataLimit?'secondary':'primary'" v-for="dataLimitMode in $options.dataLimitModes" :key="dataLimitMode"              
             @click="$store.myActions.UI_SET_GRA_DATA({uiid,name:'dataLimit',value:dataLimitMode})" >{{$t(`Pilot.Graphics.LimitData${dataLimitMode}`)}}</v-btn>
        <v-btn small icon @click="refreshNavGraphCache()" ><v-icon>mdi-refresh</v-icon></v-btn>
      </v-layout>
      <div style="flex:1 0 auto;position:relative;" class="mr-4">
        <div class="scrollable-container" style="padding-right: 0px;left: 0px;">
   <Responsive :breakpoints="{
    small: el => el.width <= 420
  }">
  <v-layout slot-scope="el" @mousedown.prevent.stop="stopClick"  ref="detail" mt-2  row wrap>          
    <v-flex v-for="graph in navGraphs" style="position:relative;" class="inline-block px-2" :class="{sm12:el.is.small,sm6:!el.is.small}" :key="graph.id">            
        <v-btn icon @click="selectGraph(graph)" small style="position:absolute;top:-5px;left:-5px;z-index:1"><v-icon>mdi-magnify-plus</v-icon></v-btn>
        <v-flex class="inline-block w-full xs12 text-xs-center body-2 mt-1" :key="graph.name">{{tryTranslate(graph.name)}}</v-flex>                
        <div class="graph mb-2" >
          <mission-scatter-plot  
              :sciGraph="false"             
              :pointSize="1" 
              :abscisseVariable="graph.abscisse"
              :ordonneeVariable="graph.ordonnee"
              :colorVariable="graph.color"
              :uiid="uiid" 
              :prefixe="graph.id"
              :allowClick="true"
              :allowZoom="false"                        
              :marginWidth="5"   
              :offsetLegendX="5"
              :offsetLegendY="5"  
              :colorGradientWidth="5"            
              :offsetLegendColor="5"
              :xTicks="graph.xTicks"
              :yTicks="5"
              :colorTicks="5"      
              :useCacheImg="true"
              :redraw="componentRefresh"              
              :dataLimit="dataLimit"
              :mission="mission"
              :tabState="tabState"
              />        
        </div>
      </v-flex>      
  </v-layout>     
    </Responsive> </div>   </div>
     <mission-graph-hover-data
        :uiid="uiid" 
        :sciGraph="false"
        prefixe="hoverdata_nav"              
        :dataLimit="dataLimit"
        :mission="mission"
        :tabState="tabState"
     />    
    </template>
    <template v-else>
      <span class="display-2" style="margin:auto">{{$t('Pilot.Graphics.NoDataAvailable')}}</span>
    </template>        
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'  
  import {zoomIdentity} from 'd3'  
  import MissionScatterPlot from '@/components/charts/MissionScatterPlot'  
  import { dataLimitMode } from '@/models/ui/GraphUiState'  
  import MissionGraphHoverData from '@/components/mission/MissionGraphHoverData.vue'
import { AloMission } from '@/models/alo/AloMission'

  export default {
    components:{MissionScatterPlot,MissionGraphHoverData},
    props:  {
      isleft:Boolean,
      uiid:{
          type: String,
          required: true
      },
      mission:{
        type:AloMission,
        required:true
      },
      tabState:{
        required:true
      }
   },      
   name: 'MissionDetailNavigationGraphicsListGen',     
   data(){
     return {
        interval: {},
        loadingValue: 0,
        loading: false
      }
   },
   mounted() {     
     if(this.loadingData){
      this.interval = setInterval(() => {
        this.loadingValue = (this.loadingValue + 10) % 110        
      }, 1000)
     }
   },       
   computed: {
       ...mapGetters([                     
         'uistatebyuiid'
      ]),           
      loadingData() {
        return !!this.mission._dataNavigationLoading
      },      
      loadedData(){
        return !!this.mission._dataNavigationLoaded
      },
      allGraphUiState() {                
        return this.uistatebyuiid(this.uiid)
      },                       
      dataLimit(){
        return this.allGraphUiState.dataLimit
      },
      componentRefresh() {
        return this.allGraphUiState && this.allGraphUiState.refresh 
      },          
      navGraphs() {
        return this.mission.navPlotVariables.filter(v => v.autoPlot).map(currentValue => { return {
          id: currentValue.variable,
          name : currentValue.name,
          abscisse : this.mission.xNavScatterVariable,
          ordonnee : currentValue.variable,
          color : "None",
          transform : zoomIdentity,
          size : 2,
          xTicks: 3,
          dataLimit: this.dataLimit
        }})
      }
    },    
    created() {
      this.$store.myActions.UI_ENSURE_ALL_GRA_STATE(this.uiid)
      this.tryEnsureData()
      this.$options.dataLimitModes = [dataLimitMode.LAST_12H,dataLimitMode.LAST_24H,dataLimitMode.ALL]
    },
    watch : {
      uiid(newValue) {
        this.$store.myActions.UI_ENSURE_ALL_GRA_STATE(newValue)
      },
      mission(newValue) {
        this.tryEnsureData()
      },
      loadingData(newValue) {
        if(!newValue) {
          clearInterval(this.interval)
        }
        else{
          this.interval = setInterval(() => {
            this.loadingValue = (this.loadingValue + 10) % 110        
          }, 1000)
        }
      }
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {    
        tryEnsureData(){
          if(this.mission.misId != null) {            
            this.$store.myActions.MISSION_ENSURE_DATA_NAVIGATION(this.mission.misId)
          }
      },
      tryTranslate(key) {        
        const transKey = `Pilot.Graphics.${key}`
        const trad = this.$t(transKey)
        return transKey == trad?key:trad
      },
      selectGraph(graph) {                    
        this.$emit("selectGraph",graph)      
      },      
      refreshNavGraphCache(){
        this.$store.myActions.UI_REFRESH_NAV_GRAPH_CACHE(this.mission.misId)
      },
      stopClick(){

      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .graph{
    border:1px solid #ddd;
    box-sizing: content-box;
    width:100%;
    height:175px;
    position:relative;
    cursor: pointer;
  }
</style>
